import Settings from "../../../../settings/Settings";

const EVENTS = {
    SHOW_STORY: 'modules.show_story',
    HIDE_STORY: 'modules.hide_story',
    SHOW_LEADERBOARD: 'modules.show_leaderboard',
    SHOW_FRIENDS: 'modules.show_friends',
    SHOW_SHOP: 'modules.show_shop',
    SHOW_POPUP_WIP: 'show_popup_wip',
};

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 30,
    TINT: 0xffffff,
    SHADOW: { OFFSET: 2, TINT: 0x000000, ALPHA: 1 },
};
export default class Modules extends Phaser.GameObjects.Container {
    private friend!: Phaser.GameObjects.Image;
    private story!: Phaser.GameObjects.Image;
    private leaderboard!: Phaser.GameObjects.Image;
    private shop!: Phaser.GameObjects.Image;
    private relic!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);

        this.setupShop();
        this.setupFriends();
        this.setupStory();
        this.setupLeaderboard();
    }

    static get EVENTS() {
        return EVENTS;
    }

    private createLabeledIcon(x: number, y: number, frame: string, label: string, onClick: () => void) {
        const icon = this.scene.add.image(x, y, 'atlas', frame);
        icon.setInteractive({ useHandCursor: true });
        icon.on('pointerdown', onClick);
        this.add(icon);

        const text = this.scene.add.bitmapText(x, y + icon.height / 2 - 25, LABEL.FONT, label, LABEL.SIZE);
        text.setOrigin(0.5, 0);
        text.setTint(LABEL.TINT);
        text.setDropShadow(LABEL.SHADOW.OFFSET, LABEL.SHADOW.OFFSET, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(text);

        return icon;
    }


    setupShop() {
        this.shop = this.createLabeledIcon(
            70,
            420,
            'icons/shop',
            this.scene.cache.json.get('i18n')['shop'],
            () => this.scene.events.emit(EVENTS.SHOW_SHOP)
        );
    }

    setupFriends() {
        this.friend = this.createLabeledIcon(
            70,
            320,
            'icons/friend',
            this.scene.cache.json.get('i18n')['frens'],
            () => this.scene.events.emit(EVENTS.SHOW_FRIENDS)
        );
    }

    setupStory() {
        this.story = this.createLabeledIcon(
            this.scene.cameras.main.width - 70,
            320,
            'icons/story',
            this.scene.cache.json.get('i18n')['story'],
            () => this.scene.events.emit(EVENTS.SHOW_STORY)
        );
    }

    setupLeaderboard() {
        this.leaderboard = this.createLabeledIcon(
            this.scene.cameras.main.width - 70,
            420,
            'icons/leaderboard',
            this.scene.cache.json.get('i18n')['leaderboard'],
            () => this.scene.events.emit(EVENTS.SHOW_LEADERBOARD)
        );
    }
}
